
/* eslint-disable sort-keys */
const shared = {
    backgroundColor: '$modalBackground',
    color: '$modalText',
    maxWidth: '600px',
    minWidth: '300px',
}

const transcriptModal = {
    backgroundColor: '$modalTranscriptBackground',
    maxWidth: '1500px',
    width: '80%',
}

export const modal = {
    ...shared,
    $$shadowColor: '$colors$modalShadowOpacity',
    borderColor: '$modalBorder',
    borderWidth: '$modal',
    borderStyle: '$modal',
    borderRadius: '$modal',
    boxShadow: '0px 10px 30px $$shadowColor',
    fontFamily: '$modal',
    variants: {
        type: {
            assignQueues: {
                maxWidth: '1500px',
                width: '80%',
            },
            embedConfirmation: {
                maxWidth: '400px',
                width: '90%',
            },
            embedName: {
                maxWidth: '400px',
                width: '90%',
            },
            groupPermission: {
                maxWidth: '1000px',
                width: '100%',
            },
            metadata: {minWidth: '600px'},
            siteConfig: {
                maxWidth: '100%',
                width: '90%',
            },
            transcript: {...transcriptModal},
        },
    },
}

export const nativeModal = {
    ...shared,
    borderRadius: 10,
    elevation: 20,
    shadowColor: '$modalShadow',
    shadowOffset: {
        height: 10,
        width: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 30,
}

const sharedContainer = {
    alignItems: 'center' as const,
    display: 'flex' as const,
    justifyContent: 'center' as const,
}

export const modalContainer = {
    ...sharedContainer,
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: '$modal',
    fontFamily: '$modal',
    fontSize: '$modal',
    fontVariant: '$modal',
    fontWeight: '$modal',
    fontStyle: '$modal',
    lineHeight: '$modal',
    // eslint-disable-next-line sort-keys
    variants: {overlayBackground: {true: {backgroundColor: '$modalOverlay'}}},
}

export const nativeModalContainer = {
    ...sharedContainer,
    flex: 1,
}

export const modalContent = {
    maxHeight: '60vh',
    overflowY: 'auto',
    padding: '$modalPaddingVertical $modalPaddingHorizontal',
}

export const nativeModalContent = {
    paddingBottom: '$modalPaddingVertical',
    paddingLeft: '$modalPaddingHorizontal',
    paddingRight: '$modalPaddingHorizontal',
    paddingTop: '$modalPaddingVertical',
}

export const nativeModalContentText = {fontSize: '$modalContentText'}

const sharedFooter = {
    backgroundColor: '$modalFooterBackground',
    display: 'flex' as const,
    flexDirection: 'row' as const,
    justifyContent: 'flex-end' as const,
}

export const modalFooter = {
    ...sharedFooter,
    $$borderColor: '$modalFooterBorder',
    borderRadius: '0 0 $modal $modal',
    borderTop: '1px solid $$borderColor',
    padding: '$modalPaddingVertical $modalPaddingHorizontal',
    variants: {type: {transcript: {backgroundColor: '$modalTranscriptBackground'}}},
}

export const nativeModalFooter = {
    ...sharedFooter,
    alignSelf: 'stretch' as const,
    borderColor: '$modalFooterBorder',
    borderTopWidth: 1,
    paddingBottom: '$modalPaddingVertical',
    paddingLeft: '$modalPaddingHorizontal',
    paddingRight: '$modalPaddingHorizontal',
    paddingTop: '$modalPaddingVertical',
}

export const modalFooterLeft = {marginRight: 'auto'}

export const nativeModalFooterLeft = {marginRight: 'auto'}

const sharedHeader = {
    alignItems: 'center' as const,
    flexDirection: 'row' as const,
}

export const modalHeader = {
    ...sharedHeader,
    '& svg': {
        color: '$modalIcon',
        marginRight: '$modalHeaderTextMargin',
        width: '20px',
    },
    'display': 'flex',
    'fontSize': '$modalHeaderText',
    'fontWeight': '$modalHeaderText',
    'padding': '$modalPaddingVertical $modalPaddingHorizontal 0 $modalPaddingHorizontal',
    'variants': {
        type: {
            error: {'& svg': {color: '$modalIconError'}},
            metadata: {},
            success: {'& svg': {color: '$modalIconSuccess'}},
            transcript: {
                borderBottom: '1px solid $modalTranscriptBorder',
                color: '$modalTranscriptText',
                fontSize: '$modalTranscriptHeader',
                padding: '$modalPaddingVertical $modalPaddingHorizontal',
            },
            warning: {'& svg': {color: '$modalIconWarning'}},
        },
    },
}

export const nativeModalHeader = {
    ...sharedHeader,
    paddingLeft: '$modalPaddingHorizontal',
    paddingRight: '$modalPaddingHorizontal',
    paddingTop: '$modalPaddingVertical',
}

export const nativeModalHeaderText = {
    fontSize: '$modalHeaderText',
    fontWeight: '$modalHeaderText' as const,
    variants: {withIcon: {true: {marginLeft: '$modalHeaderTextMargin'}}},
}
